import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';

const DeliveryInfoSkeleton = () => {
  // Helper function to create skeleton cards
  const createSkeletonCard = (index) => (
    <Box key={index} className="card" sx={{ gap: '5px !important' }}>
      {/* Icon skeleton */}
      <Skeleton 
        variant="rectangular" 
        width={32} 
        height={22} 
        sx={{ 
          borderRadius: '6px',
          marginBottom: '5px',
          marginTop: '23px'
        }}
      />
      
      {/* Amount skeleton */}
      <Skeleton 
        variant="text" 
        width={60} 
        height={32}
        sx={{ marginBottom: '5px' }}
      />
      
      {/* Text/Label skeleton */}
      <Skeleton 
        variant="text" 
        width={80} 
        height={20}
        sx={{ marginBottom: '5px' }}
      />
      
      {/* Percentage skeleton */}
      <Skeleton 
        variant="text" 
        width={50} 
        height={24}
      />
    </Box>
  );

  // Create 5 tracking cards
  const trackingCards = Array.from({ length: 5 }, (_, index) => createSkeletonCard(index));
  
  // Temporarily hidden with the scan cards in DeliveryInfo. Restore this with the scanning section below if needed.
  // const scanningCards = Array.from({ length: 3 }, (_, index) => createSkeletonCard(index));

  return (
    <Box className="tracking_details_wrapper">
      <Typography variant="h6" className="trackingDetailsTitle">
        Tracking Details
      </Typography>
      <Box className="delivery_info_container">
        {/* Tracking Section */}
        <Box className="delivery_info">
          <Box className="card_outer">
            {trackingCards}
          </Box>
        </Box>

        {/* Scanning Section - temporarily hidden.
        <Box className="delivery_info">
          <Box className="card_outer">
            {scanningCards}
          </Box>
        </Box> */}
      </Box>
    </Box>
  );
};

export default DeliveryInfoSkeleton;
